<template>
    <component :is="isConnected ? layout : layoutWithoutNav">
        <router-view />
    </component>
    <Toaster v-if="hasErrorActive" :message="toasterMessage" />
</template>

<script lang="ts">
import { defineComponent, shallowRef } from 'vue';
import Layout from '@/components/layout/Layout.vue';
import LayoutWithoutNav from '@/components/layout/LayoutWithoutNav.vue';
import { store } from '@/plugins/store';
import Toaster from './components/ui-components/Toaster.vue';
import Modal from '@/components/ui-components/Modal.vue';
import WaitingModal from '@/components/ui-components/WaitingModal.vue';

export default defineComponent({
    name: 'App',
    components: {
        WaitingModal,
        Toaster,
        Modal,
    },
    data() {
        const layout = shallowRef(Layout);
        const layoutWithoutNav = shallowRef(LayoutWithoutNav);
        return {
            layout,
            layoutWithoutNav,
        };
    },
    mounted() {
        const jwtToken = localStorage.getItem('token_portail_partenaire');
        localStorage.setItem('botActive', 'false');
        if (
            this.$store.getters['authenticationState/isSignInAzureIsSuccessful'] &&
            jwtToken &&
            localStorage.getItem('botActive') !== 'true' &&
            !this.isLogin
        ) {
            const botScript = document.createElement('script');
            botScript.setAttribute(
                'src',
                'https://storage.googleapis.com/ideta-prod.appspot.com/bots/-O4oH__QZ9sdXcHTH5OC/scripts/integration-web.js?GoogleAccessId=firebase-adminsdk-4b3yf%40ideta-prod.iam.gserviceaccount.com&Expires=16447017600&Signature=kMpAB4VeZ%2Bbh8OFLolxamhrOJ7zJt8vz2uKR0K%2BRv8%2BmS5haRuQIxrqstVfWqXRNquFMV73OvUjArfw2KWPhBKBVNQe48D%2BfiUomlWhL%2BbBoCnOmmA2jlrNM3mtxF%2B8CcuZHmq4xtcQYj4LG3XLefiVS0dkPSBg0eh3pfO1qGF%2FC6igMtxW0M4FObdLVOzz2RzUuxcbDFN6dj1fBm8%2BF1TsBpjvJeudySvn6yFoLKQ9dwnOc1bYymNSeE%2F5B3K6okhq4k6X9eczVmbaa88%2F7XSiklqgBysyZRDY15JN9yHZRy%2F%2FN3ybMs4K6uIpVFGnYnTu8%2BDnXnsFwKlw374Ti2Q%3D%3D'
            );
            botScript.setAttribute('type', 'text/javascript');
            botScript.setAttribute('async', '');
            document.head.appendChild(botScript);
            localStorage.setItem('botActive', 'true');
        }
    },
    computed: {
        hasErrorActive() {
            return store.state.errorToaster.activeToast;
        },
        toasterMessage() {
            return store.state.errorToaster.message;
        },
        isConnected() {
            return (
                store.state.authenticationState.signInAzureIsSuccessful &&
                store.state.authState.token !== '' &&
                store.state.authState.token !== null &&
                !this.isLogin
            );
        },
        isLogin(): boolean {
            return (
                this.$router.currentRoute.value.fullPath === '/login' ||
                this.$router.currentRoute.value.fullPath === '/noteReclamation' ||
                this.$router.currentRoute.value.name === 'note2' ||
                this.$router.currentRoute.value.path === '/validation-devis' ||
                this.$router.currentRoute.value.name === 'validationDevis' ||
                this.$router.currentRoute.value.path?.startsWith('/validation-devis')
            );
        },
        isPortailClient(): boolean {
            return store.getters['authenticationState/getPortailName'] === 'Client';
        },
    },
});
</script>

<style></style>
